import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Menu, X } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";

const LINKS = [
  { label: "How we grow", href: "#growth" },
  { label: "Firms", href: "#firms" },
  { label: "Reviews", href: "#reviews" },
  { label: "About", href: "#about" },
];

export const SiteNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`sticky top-0 z-50 glass border-b transition-shadow ${scrolled ? "shadow-sm" : "border-transparent"}`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link"><Logo /></Link>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-2">
          <ThemeToggle />
          {user ? (
            <Button data-testid="nav-portal-button" onClick={() => navigate("/portal")} className="rounded-xl bg-primary text-primary-foreground">Open Portal</Button>
          ) : (
            <>
              <Button data-testid="nav-login-button" variant="ghost" className="rounded-xl" onClick={() => navigate("/login")}>Client Login</Button>
              <Button data-testid="nav-request-access-button" className="rounded-xl bg-[#0EA5A4] hover:bg-[#0B8E8D] text-white" onClick={() => document.getElementById("request-access")?.scrollIntoView({ behavior: "smooth" })}>Request Access</Button>
            </>
          )}
        </div>
        <div className="md:hidden flex items-center gap-1">
          <ThemeToggle testId="theme-toggle-button-mobile" />
          <button data-testid="nav-mobile-toggle" className="p-2" onClick={() => setOpen(!open)}>
            {open ? <X className="size-5" /> : <Menu className="size-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t bg-white dark:bg-background px-4 py-4 space-y-3">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="block text-sm text-muted-foreground">{l.label}</a>
          ))}
          <div className="flex gap-2 pt-2">
            <Button variant="outline" className="flex-1 rounded-xl" onClick={() => navigate("/login")}>Login</Button>
            <Button className="flex-1 rounded-xl bg-[#0EA5A4] text-white" onClick={() => { setOpen(false); document.getElementById("request-access")?.scrollIntoView({ behavior: "smooth" }); }}>Request Access</Button>
          </div>
        </div>
      )}
    </header>
  );
};
